/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageDto } from './MessageDto';
import {
    MessageDtoFromJSON,
    MessageDtoFromJSONTyped,
    MessageDtoToJSON,
    MessageDtoToJSONTyped,
} from './MessageDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface MessagesResponseDto
 */
export interface MessagesResponseDto {
    /**
     * List of messages
     * @type {Array<MessageDto>}
     * @memberof MessagesResponseDto
     */
    messages: Array<MessageDto>;
    /**
     * Pagination metadata
     * @type {PaginationDto}
     * @memberof MessagesResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the MessagesResponseDto interface.
 */
export function instanceOfMessagesResponseDto(value: object): value is MessagesResponseDto {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function MessagesResponseDtoFromJSON(json: any): MessagesResponseDto {
    return MessagesResponseDtoFromJSONTyped(json, false);
}

export function MessagesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessagesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(MessageDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function MessagesResponseDtoToJSON(json: any): MessagesResponseDto {
    return MessagesResponseDtoToJSONTyped(json, false);
}

export function MessagesResponseDtoToJSONTyped(value?: MessagesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': ((value['messages'] as Array<any>).map(MessageDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

